<div class="maintenance" role="alert" aria-live="assertive">
  <div class="maintenance__card">
    <div class="maintenance__icon" aria-hidden="true">
      <i class="material-icons">construction</i>
    </div>

    <h2 class="maintenance__title">We'll be right back</h2>

    <p class="maintenance__text">
      We're having trouble reaching our servers, most likely due to scheduled
      maintenance. Booking is temporarily unavailable, please check back soon.
    </p>

    <button type="button"
      class="maintenance__btn"
      (click)="refresh()">
      <i class="material-icons" aria-hidden="true">refresh</i>
      Refresh
    </button>
  </div>
</div>
